export const OPERATOR_ROLE = 1;
export const MODERATOR_ROLE = 2;
export const SUPER_ADMIN_ROLE = 3;
export const COURIER_ROLE = 4;
export const INTERN_ROLE = 5;
export const INTERN_OPERATOR_ROLE = 6;
